export enum BookingScreenType {
  Management = 'management',
  Links = 'links',
  LockedTimeSlots = 'locked-time-slots',
  Timeline = 'timeline',
}
